import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12.756 22a10.02 10.02 0 0 0 8.414-4.556.72.72 0 0 0 .026-.738.68.68 0 0 0-.64-.367l-.17.01c-4.748 0-8.612-3.847-8.612-8.576 0-1.659.482-3.272 1.394-4.668A.714.714 0 0 0 12.556 2c-5.427.107-9.841 4.59-9.841 9.996C2.715 17.512 7.219 22 12.755 22m-1.47-18.447a9.9 9.9 0 0 0-.94 4.22c0 5.107 3.862 9.334 8.83 9.931a8.6 8.6 0 0 1-6.42 2.867c-4.749 0-8.612-3.847-8.612-8.575 0-4.193 3.102-7.74 7.142-8.443"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }